import { render, staticRenderFns } from "./create-lists.vue?vue&type=template&id=78c2ef2e"
import script from "./create-lists.vue?vue&type=script&lang=js"
export * from "./create-lists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports